import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const InfoSec = styled.div`
  color: #fff;
  padding: 50px 0; 
  background: ${({ lightBg }) => (lightBg ? '#fff' : '#c9d66a')};
  box-shadow: ${({ boxsh }) => (boxsh ? '0px 0px 23px 6px rgba(0,0,0,0.1)' : '0px 0px 0px 6px rgba(0,0,0,0)')};
  border-radius:10px;
  background-color: #fff;

`;
export const ButtoCon = styled(Link)`

text-decoration:none;
 @media screen and (max-width: 768px) {
    max-width: 100%;
    margin-top:15px
 }

`;


export const Buttonh = styled.button`
width:600px;
 border-radius: 4px;
  background: ${({ primary }) => (primary ? '#eb594c' : '#c9d66a')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  color: #fff;
  font-size:20px;
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background-color: ${({ primary }) => (primary ? '#c9d66a' : '#eb594c')};
  }
 @media screen and (max-width: 768px) {
    max-width: 400px;
    margin:0
 }

`;
export const InfoRow = styled.div`
  display: flex;
  margin: 0 -15px -15px -15px;
  flex-wrap: wrap;
  align-items: center;
  /* flex-direction: ${({ imgStart }) => (imgStart ? 'row-reverse' : 'row')}; */
  box-shadow: 0 6px 20px rgba(0,0,0,0.05);
  background-color: #fff;

`;

export const InfoColumn = styled(Link)`
  margin-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  flex: 1;
    text-decoration: none;
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  margin-bottom:10px;
  padding-top: 0;
  /* background: ${({ lightBg }) => (lightBg ? '#fff' : '#c9d66a')}; */
    text-align:left;
align-items:center;
  @media screen and (max-width: 768px) {
    padding-bottom: 65px;
    padding-right:30px;
    overflow:hidden
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  /* justify-content:'flex-end' */
  /* justify-content: ${({ start }) => (start ? 'flex-start' : 'flex-end')}; */
`;

export const TopLine = styled.div`
  color:'#fff' ;
  font-size: 18px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  width: 210px;
  height: 30px;
  padding-top:5px;
  padding-left:10px;
  margin-bottom: 16px;
margin-left: 80px;
  background-color: ${({ bglight }) => (bglight ? '#fff' : '#909284')};
`;

export const Imgg = styled.img`
 width:  1519px;
  display: block;
 height:650px ;
    @media screen and (max-width: 768px) {
     max-width: 100%;
     max-height: 400px;
  }
`;

export const Img = styled.img`
  padding-bottom: 110px;
  border: 0;
  max-width: 100%;
  margin-top:80px;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? '#eb594c' : '#fff')};
    margin-left:80px;

`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  margin-left:80px;
  font-size: 20px;
  line-height: 30px;
  text-align:left;
  color: ${({ lightTextDesc }) => (lightTextDesc ? '#909284' : '#fff')};



`;
